import { DesktopDatePicker, LocalizationProvider } from "@mui/lab"
import AdapterDateFns from "@mui/lab/AdapterDateFns"
import { Box, TextField } from "@mui/material"
import React from "react"
import { Control, Controller } from "react-hook-form"

interface UseFormDesktopDatePickerProps {
  control: Control
  name: string
  label: string
}

export const UseFormDesktopDatePicker: React.FC<UseFormDesktopDatePickerProps> = ({
  control,
  name,
  label
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({field, formState: {errors}}) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            {...field}
            inputFormat="yyyy/MM/dd"
            mask="____/__/__"
            renderInput={(params) => (
              <Box
                sx={{
                  width: '170px',
                  height: '40px',
                }}
              >
                <TextField
                  {...params}
                  size={'small'}
                  inputProps={{
                    ...params.inputProps,
                    placeholder: label,
                    style: { fontSize: 14 },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-input': {
                      padding: '7px 14px',
                      height: 'auto',
                    },
                    fontStyle: 'normal',
                    lineHeight: '20px',
                    letterSpacing: 0.15,
                    background: 'white',
                  }}
                />
              </Box>
            )}
          />
        </LocalizationProvider>
      )}
    />
  )
}